import {HttpHeaders} from "@angular/common/http";

export class Headers {
  /**
   * Headers attached to the request.
   * almost every place where we make a request
   *
   * @private
   * @param {string} token
   * @returns {HttpHeaders}
   */
  public static headers(token: string): HttpHeaders {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: 'Basic ' + token,
    });
  }
}
